module.exports = __webpack_public_path__ + "static/media/sawmill_thumb.8cd5d168.png";